import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { contextConnect } from '@wp-g2/context';
import React from 'react';
import { DropdownMenuCard } from '../Dropdown';
import { Portal } from '../Portal';
import { Select } from '../Select';
import { Truncate } from '../Truncate';
import { View } from '../View';
import SelectDropdownItem from './select-dropdown-item';
import SelectDropdownLabel from './select-dropdown-label';
import { useSelectDropdown } from './use-select-dropdown';

function SelectDropdown(props, forwardedRef) {
  var _useSelectDropdown = useSelectDropdown(props),
      dropdownMenuProps = _useSelectDropdown.dropdownMenuProps,
      hideLabelFromVision = _useSelectDropdown.hideLabelFromVision,
      isOpen = _useSelectDropdown.isOpen,
      items = _useSelectDropdown.items,
      label = _useSelectDropdown.label,
      labelProps = _useSelectDropdown.labelProps,
      placeholder = _useSelectDropdown.placeholder,
      popoverProps = _useSelectDropdown.popoverProps,
      popoverRef = _useSelectDropdown.popoverRef,
      referenceProps = _useSelectDropdown.referenceProps,
      referenceRef = _useSelectDropdown.referenceRef,
      resizer = _useSelectDropdown.resizer,
      otherProps = _objectWithoutProperties(_useSelectDropdown, ["dropdownMenuProps", "hideLabelFromVision", "isOpen", "items", "label", "labelProps", "placeholder", "popoverProps", "popoverRef", "referenceProps", "referenceRef", "resizer"]);

  return /*#__PURE__*/React.createElement(View, Object.assign({}, otherProps, {
    ref: forwardedRef
  }), resizer, /*#__PURE__*/React.createElement(Select, Object.assign({
    as: "button"
  }, referenceProps), /*#__PURE__*/React.createElement(Truncate, null, referenceProps.children)), /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(View, popoverProps, /*#__PURE__*/React.createElement(SelectDropdownLabel, labelProps), isOpen && /*#__PURE__*/React.createElement(DropdownMenuCard, dropdownMenuProps, items.map(function (item) {
    return /*#__PURE__*/React.createElement(SelectDropdownItem, item);
  })))));
}

export default contextConnect(SelectDropdown, 'SelectDropdown');